module.exports = {"TXTMOB_Win_up_to_N0X":{"id":"TXTMOB_Win_up_to_N0X","defaultMessage":"Nyerj akár {0}-t!"}}